import axios from "axios";
const API = axios.create({baseURL:`${process.env.REACT_APP_BACKEND_URL}`,withCredentials: true});
API.defaults.headers.post["Content-Type"] = "application/json";
class UserService {
    static register(data)
    {
        let url = `/api/users/register`;
        return API.post(url,data);
    }
    static generateOTP(data) {
        let url = '/api/users/get-otp';
        return API.post(url,data);
    }
    static validateEmail(data) {
        let url = '/api/users/validate-otp';
        return API.patch(url,data);
    }
    static login(data)
    {
        let url = `/api/users/login`;
        return API.post(url,data);
    }
    static fetchOrders()
    {
        let url = '/api/users/orders';
        return API.get(url,{});
    }
    static logOut()
    {
        let url = '/api/users/logout';
        return API.get(url,{});
    }
    static getUserData()
    {
        let url = `/api/users/me`;
        return API.get(url,{});
    }
}
export default UserService;